import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _6ffbdcfe = () => interopDefault(import('../pages/30-jahre-telekom.vue' /* webpackChunkName: "pages/30-jahre-telekom" */))
const _10de948d = () => interopDefault(import('../pages/30-jahre-telekom-endgeraete.vue' /* webpackChunkName: "pages/30-jahre-telekom-endgeraete" */))
const _5ca6251e = () => interopDefault(import('../pages/a-good-company.vue' /* webpackChunkName: "pages/a-good-company" */))
const _6a4d2a66 = () => interopDefault(import('../pages/anker/index.vue' /* webpackChunkName: "pages/anker/index" */))
const _3e427432 = () => interopDefault(import('../pages/bitte-kommen-sie-spaeter-wieder.vue' /* webpackChunkName: "pages/bitte-kommen-sie-spaeter-wieder" */))
const _bebcf7d8 = () => interopDefault(import('../pages/google/index.vue' /* webpackChunkName: "pages/google/index" */))
const _ec0d41fe = () => interopDefault(import('../pages/handyrechnung-aktion.vue' /* webpackChunkName: "pages/handyrechnung-aktion" */))
const _6dc47382 = () => interopDefault(import('../pages/handyvergleich.vue' /* webpackChunkName: "pages/handyvergleich" */))
const _67fda394 = () => interopDefault(import('../pages/infos-zum-online-kauf.vue' /* webpackChunkName: "pages/infos-zum-online-kauf" */))
const _64a4efb8 = () => interopDefault(import('../pages/kontakt.vue' /* webpackChunkName: "pages/kontakt" */))
const _257a9baa = () => interopDefault(import('../pages/maintenance.vue' /* webpackChunkName: "pages/maintenance" */))
const _2631a424 = () => interopDefault(import('../pages/merkliste.vue' /* webpackChunkName: "pages/merkliste" */))
const _2b71401e = () => interopDefault(import('../pages/oster-angebote.vue' /* webpackChunkName: "pages/oster-angebote" */))
const _f988672c = () => interopDefault(import('../pages/panzerglass.vue' /* webpackChunkName: "pages/panzerglass" */))
const _7a249b14 = () => interopDefault(import('../pages/preisvorteile-sichern.vue' /* webpackChunkName: "pages/preisvorteile-sichern" */))
const _1e62616d = () => interopDefault(import('../pages/ratenzahlung.vue' /* webpackChunkName: "pages/ratenzahlung" */))
const _c34bdfc4 = () => interopDefault(import('../pages/redirecting.vue' /* webpackChunkName: "pages/redirecting" */))
const _fce676d6 = () => interopDefault(import('../pages/samsung/index.vue' /* webpackChunkName: "pages/samsung/index" */))
const _4a999296 = () => interopDefault(import('../pages/samsung-cashback-aktion.vue' /* webpackChunkName: "pages/samsung-cashback-aktion" */))
const _fbfea82a = () => interopDefault(import('../pages/smart-home-entdecken.vue' /* webpackChunkName: "pages/smart-home-entdecken" */))
const _f7f1da74 = () => interopDefault(import('../pages/soundcore.vue' /* webpackChunkName: "pages/soundcore" */))
const _533adeda = () => interopDefault(import('../pages/stabiles-internet.vue' /* webpackChunkName: "pages/stabiles-internet" */))
const _4c4b6e9c = () => interopDefault(import('../pages/themenwelten.vue' /* webpackChunkName: "pages/themenwelten" */))
const _539743d3 = () => interopDefault(import('../pages/xiaomi.vue' /* webpackChunkName: "pages/xiaomi" */))
const _4aaa7854 = () => interopDefault(import('../pages/xiaomi-smartphones.vue' /* webpackChunkName: "pages/xiaomi-smartphones" */))
const _005025c8 = () => interopDefault(import('../pages/xiaomi-zubehoer.vue' /* webpackChunkName: "pages/xiaomi-zubehoer" */))
const _386086c0 = () => interopDefault(import('../pages/zahlung-per-handyrechnung.vue' /* webpackChunkName: "pages/zahlung-per-handyrechnung" */))
const _937fc13e = () => interopDefault(import('../pages/anker/product-data.ts' /* webpackChunkName: "pages/anker/product-data" */))
const _46ac054e = () => interopDefault(import('../pages/google/product-data.js' /* webpackChunkName: "pages/google/product-data" */))
const _47aea676 = () => interopDefault(import('../pages/hilfe/lieferstatus-und-retoure.vue' /* webpackChunkName: "pages/hilfe/lieferstatus-und-retoure" */))
const _5a2e73d6 = () => interopDefault(import('../pages/magenta-black-days/page-data.js' /* webpackChunkName: "pages/magenta-black-days/page-data" */))
const _58291a50 = () => interopDefault(import('../pages/samsung/product-data.ts' /* webpackChunkName: "pages/samsung/product-data" */))
const _28051296 = () => interopDefault(import('../pages/shop/bestaetigung.vue' /* webpackChunkName: "pages/shop/bestaetigung" */))
const _021854a6 = () => interopDefault(import('../pages/shop/brodos-zahlungsverifizierung.vue' /* webpackChunkName: "pages/shop/brodos-zahlungsverifizierung" */))
const _2cb1b17e = () => interopDefault(import('../pages/shop/fehler.vue' /* webpackChunkName: "pages/shop/fehler" */))
const _4088d434 = () => interopDefault(import('../pages/shop/kundenformular.vue' /* webpackChunkName: "pages/shop/kundenformular" */))
const _fac4d02e = () => interopDefault(import('../pages/shop/kundenformular/index.vue' /* webpackChunkName: "pages/shop/kundenformular/index" */))
const _a9b2b866 = () => interopDefault(import('../pages/shop/kundenformular/persoenliche-daten.vue' /* webpackChunkName: "pages/shop/kundenformular/persoenliche-daten" */))
const _f83624ec = () => interopDefault(import('../pages/shop/kundenformular/zahlungsart.vue' /* webpackChunkName: "pages/shop/kundenformular/zahlungsart" */))
const _55e68223 = () => interopDefault(import('../pages/shop/telekom-bestaetigung.vue' /* webpackChunkName: "pages/shop/telekom-bestaetigung" */))
const _f1f89120 = () => interopDefault(import('../pages/shop/telekom-bezahlung-information.vue' /* webpackChunkName: "pages/shop/telekom-bezahlung-information" */))
const _096e1d2a = () => interopDefault(import('../pages/shop/telekom-zahlungsverifizierung.vue' /* webpackChunkName: "pages/shop/telekom-zahlungsverifizierung" */))
const _13692264 = () => interopDefault(import('../pages/shop/warenkorb.vue' /* webpackChunkName: "pages/shop/warenkorb" */))
const _3dcc2cd8 = () => interopDefault(import('../pages/shop/zahlungsverifizierung.vue' /* webpackChunkName: "pages/shop/zahlungsverifizierung" */))
const _68b8ed60 = () => interopDefault(import('../pages/shop/zusammenfassung.vue' /* webpackChunkName: "pages/shop/zusammenfassung" */))
const _324d30cc = () => interopDefault(import('../pages/weitere-informationen/agb-brodos.vue' /* webpackChunkName: "pages/weitere-informationen/agb-brodos" */))
const _6fe81c85 = () => interopDefault(import('../pages/weitere-informationen/sitemap.vue' /* webpackChunkName: "pages/weitere-informationen/sitemap" */))
const _11129ab7 = () => interopDefault(import('../pages/weitere-informationen/ueber-brodos.vue' /* webpackChunkName: "pages/weitere-informationen/ueber-brodos" */))
const _69c3b24e = () => interopDefault(import('../pages/weitere-informationen/ueber-qivicon.vue' /* webpackChunkName: "pages/weitere-informationen/ueber-qivicon" */))
const _e53b1f2c = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _4c9ab111 = () => interopDefault(import('../pages/magenta-moments-2024/_slug.vue' /* webpackChunkName: "pages/magenta-moments-2024/_slug" */))
const _f4e4b032 = () => interopDefault(import('../special-pages/product-details.vue' /* webpackChunkName: "" */))
const _ffccdd50 = () => interopDefault(import('../special-pages/shop-list.vue' /* webpackChunkName: "" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/30-jahre-telekom",
    component: _6ffbdcfe,
    name: "30-jahre-telekom"
  }, {
    path: "/30-jahre-telekom-endgeraete",
    component: _10de948d,
    name: "30-jahre-telekom-endgeraete"
  }, {
    path: "/a-good-company",
    component: _5ca6251e,
    name: "a-good-company"
  }, {
    path: "/anker",
    component: _6a4d2a66,
    name: "anker"
  }, {
    path: "/bitte-kommen-sie-spaeter-wieder",
    component: _3e427432,
    name: "bitte-kommen-sie-spaeter-wieder"
  }, {
    path: "/google",
    component: _bebcf7d8,
    name: "google"
  }, {
    path: "/handyrechnung-aktion",
    component: _ec0d41fe,
    name: "handyrechnung-aktion"
  }, {
    path: "/handyvergleich",
    component: _6dc47382,
    name: "handyvergleich"
  }, {
    path: "/infos-zum-online-kauf",
    component: _67fda394,
    name: "infos-zum-online-kauf"
  }, {
    path: "/kontakt",
    component: _64a4efb8,
    name: "kontakt"
  }, {
    path: "/maintenance",
    component: _257a9baa,
    name: "maintenance"
  }, {
    path: "/merkliste",
    component: _2631a424,
    name: "merkliste"
  }, {
    path: "/oster-angebote",
    component: _2b71401e,
    name: "oster-angebote"
  }, {
    path: "/panzerglass",
    component: _f988672c,
    name: "panzerglass"
  }, {
    path: "/preisvorteile-sichern",
    component: _7a249b14,
    name: "preisvorteile-sichern"
  }, {
    path: "/ratenzahlung",
    component: _1e62616d,
    name: "ratenzahlung"
  }, {
    path: "/redirecting",
    component: _c34bdfc4,
    name: "redirecting"
  }, {
    path: "/samsung",
    component: _fce676d6,
    name: "samsung"
  }, {
    path: "/samsung-cashback-aktion",
    component: _4a999296,
    name: "samsung-cashback-aktion"
  }, {
    path: "/smart-home-entdecken",
    component: _fbfea82a,
    name: "smart-home-entdecken"
  }, {
    path: "/soundcore",
    component: _f7f1da74,
    name: "soundcore"
  }, {
    path: "/stabiles-internet",
    component: _533adeda,
    name: "stabiles-internet"
  }, {
    path: "/themenwelten",
    component: _4c4b6e9c,
    name: "themenwelten"
  }, {
    path: "/xiaomi",
    component: _539743d3,
    name: "xiaomi"
  }, {
    path: "/xiaomi-smartphones",
    component: _4aaa7854,
    name: "xiaomi-smartphones"
  }, {
    path: "/xiaomi-zubehoer",
    component: _005025c8,
    name: "xiaomi-zubehoer"
  }, {
    path: "/zahlung-per-handyrechnung",
    component: _386086c0,
    name: "zahlung-per-handyrechnung"
  }, {
    path: "/anker/product-data",
    component: _937fc13e,
    name: "anker-product-data"
  }, {
    path: "/google/product-data",
    component: _46ac054e,
    name: "google-product-data"
  }, {
    path: "/hilfe/lieferstatus-und-retoure",
    component: _47aea676,
    name: "hilfe-lieferstatus-und-retoure"
  }, {
    path: "/magenta-black-days/page-data",
    component: _5a2e73d6,
    name: "magenta-black-days-page-data"
  }, {
    path: "/samsung/product-data",
    component: _58291a50,
    name: "samsung-product-data"
  }, {
    path: "/shop/bestaetigung",
    component: _28051296,
    name: "shop-bestaetigung"
  }, {
    path: "/shop/brodos-zahlungsverifizierung",
    component: _021854a6,
    name: "shop-brodos-zahlungsverifizierung"
  }, {
    path: "/shop/fehler",
    component: _2cb1b17e,
    name: "shop-fehler"
  }, {
    path: "/shop/kundenformular",
    component: _4088d434,
    children: [{
      path: "",
      component: _fac4d02e,
      name: "shop-kundenformular"
    }, {
      path: "persoenliche-daten",
      component: _a9b2b866,
      name: "shop-kundenformular-persoenliche-daten"
    }, {
      path: "zahlungsart",
      component: _f83624ec,
      name: "shop-kundenformular-zahlungsart"
    }]
  }, {
    path: "/shop/telekom-bestaetigung",
    component: _55e68223,
    name: "shop-telekom-bestaetigung"
  }, {
    path: "/shop/telekom-bezahlung-information",
    component: _f1f89120,
    name: "shop-telekom-bezahlung-information"
  }, {
    path: "/shop/telekom-zahlungsverifizierung",
    component: _096e1d2a,
    name: "shop-telekom-zahlungsverifizierung"
  }, {
    path: "/shop/warenkorb",
    component: _13692264,
    name: "shop-warenkorb"
  }, {
    path: "/shop/zahlungsverifizierung",
    component: _3dcc2cd8,
    name: "shop-zahlungsverifizierung"
  }, {
    path: "/shop/zusammenfassung",
    component: _68b8ed60,
    name: "shop-zusammenfassung"
  }, {
    path: "/weitere-informationen/agb-brodos",
    component: _324d30cc,
    name: "weitere-informationen-agb-brodos"
  }, {
    path: "/weitere-informationen/sitemap",
    component: _6fe81c85,
    name: "weitere-informationen-sitemap"
  }, {
    path: "/weitere-informationen/ueber-brodos",
    component: _11129ab7,
    name: "weitere-informationen-ueber-brodos"
  }, {
    path: "/weitere-informationen/ueber-qivicon",
    component: _69c3b24e,
    name: "weitere-informationen-ueber-qivicon"
  }, {
    path: "/",
    component: _e53b1f2c,
    name: "index"
  }, {
    path: "/magenta-moments-2024/:slug?",
    component: _4c9ab111,
    name: "magenta-moments-2024-slug"
  }, {
    path: "/geraete/:slug?",
    component: _f4e4b032,
    name: "ProductDetails"
  }, {
    path: "/:config+",
    component: _ffccdd50,
    name: "ShopList"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
